<template>
    <cell-loader v-if="value.loading" />
    <div v-else class="pattern">
        <div class="pattern__content">
            <patternEditor
                ref="editor"
                v-if="isNewPattern"
                v-model="localTmpValue"
                :placeholder="placeholder"
            />
            <patternEditor
                v-else
                ref="editor"
                v-model="tmpValue"
                :placeholder="placeholder"
                :readonly="!isEditMode"
            />
        </div>
        <div class="pattern__actions" v-if="!isNewPattern">
            <div
                v-if="isEditMode"
                class="btns-wrap"
            >
                <or-icon-button
                    class="flat"
                    icon="close"
                    type="secondary"
                    size="small"
                    @click="discardChanges"
                />
                <or-icon-button
                    class="flat"
                    icon="check"
                    type="secondary"
                    :disabled="!isPatternValid"
                    @click="saveChanges"
                    size="small"
                />
            </div>
            <or-icon-button
                v-else
                has-dropdown
                disable-ripple
                class="flat"
                ref="dropdownButton"
                icon="more_vert"
                size="small"
                type="secondary"
            >
                <or-menu
                    contain-focus
                    has-icons
                    slot="dropdown"
                    :options="menuOptions"
                    @select="onSelectMenu"
                    @close="$refs.dropdownButton.closeDropdown()"
                />
            </or-icon-button>
        </div>
        <or-confirm
            ref="deleteConfirm"
            :title="$t('common.pattern.pattern.deletePattern')"
            @confirm="deletePattern(value)"
        >
          {{ $t('common.pattern.pattern.doYouWant') }}
        </or-confirm>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import patternEditor from './pattern_editor'
import cellLoader from '../../table/table_stuff/cell_loader'
import { PATTERNS_STRONG_SYNTAX } from './patter-types'

export default {

  components: {
    cellLoader,
    patternEditor
  },

  data () {
    return {
      tmpValue: this.parsePattern(this.value),
      isEditMode: false
    }
  },

  computed: {
    isPatternValid () {
      if (this.$refs.editor) {
        console.log('invalid:', this.$refs.editor.$v.value)
        return !this.$refs.editor.$v.value.$invalid
      }
      return true
    },

    menuOptions () {
      return [{
        id: 'edit',
        label: this.$t('common.pattern.pattern.editPattern'),
        icon: 'edit'
      }, {
        id: 'delete',
        label: this.$t('common.pattern.pattern.deletePattern'),
        icon: 'delete'
      }]
    },
    localValue: {
      get () {
        return this.parsePattern(this.value)
      },
      set (value) {
        this.$emit('input', this.stringifyPattern(value))
      }
    },

    localTmpValue: {
      get () {
        return this.tmpValue
      },
      set (value) {
        console.log({ value })
        this.tmpValue = value
        this.$emit('input', this.stringifyPattern(value))
      }
    }
  },

  methods: {
    ...mapActions('knowledgebase/patterns', ['deletePattern', 'updatePattern']),

    async saveChanges () {
      await this.updatePattern({
        ...this.value,
        ...this.stringifyPattern(this.tmpValue)
      })
      this.isEditMode = false
    },

    discardChanges () {
      this.isEditMode = false
      this.tmpValue = this.parsePattern(this.value)
    },

    // Pattern: string e.g. "({} | raw text)."
    // We're parsing it into array: ["(", "{}", " ", "|", " raw text", ")", "."]
    parsePattern ({ pattern, entities }) {
      const reg = /[|()[\]]|({})/gi
      let execRes
      let index = 0
      let patternArr = []
      while ((execRes = reg.exec(pattern)) !== null) {
        patternArr.push(
          pattern.slice(index, execRes.index),
          execRes[0]
        )
        index = execRes.index + execRes[0].length
      }

      patternArr = _.compact(patternArr)
      let entityIndex = 0

      const arr = _.chain(patternArr)
        .map(el => {
          if (el === '{}') {
            return {
              path: entities[entityIndex++]
            }
          } else if (PATTERNS_STRONG_SYNTAX.includes(el)) {
            return {
              strong: el
            }
          } else {
            return el
          }
        })
        .compact()
        .value()
      console.log({ arr })
      return arr
    },
    stringifyPattern (patternArr) {
      let order = 0
      const entities = _.reduce(patternArr, (prev, el) => {
        if (el.path) {
          const { role, entity } = el.path
          prev.push({ role, entity, order })
          ++order
        }
        return prev
      }, [])
      const pattern = _.map(patternArr, el => {
        if (el.path) {
          return '{}'
        } else if (el.strong) {
          return el.strong
        }
        return el
      }).join('')
      return { pattern, entities }
    },
    onSelectMenu ({ id }) {
      switch (id) {
        case 'edit':
          this.isEditMode = true
          break
        case 'delete':
          this.$refs.deleteConfirm.open()
          break
        default:
          break
      }
    }
  },
  props: {
    placeholder: String,
    value: {
      type: Object,
      default: () => ({
        pattern: '',
        entities: []
      })
    },
    isNewPattern: Boolean
  },
  watch: {
    isEditMode (value) {
      if (value) {
        this.$emit('hide-add-btn')
      } else {
        this.$emit('show-add-btn')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.pattern{
    display: flex;
    &__content{
        flex:1;
    }
}
</style>
